module.exports = __webpack_public_path__ + "img/classic_2.747e9e18.jpg";